import React from 'react';
import moment from 'moment';
import { AppLink } from '../../routing/containers';
import { ItemActions as InquiryActions } from '../inquiry/containers';
import { ItemActions as ReservationActions } from '../reservation/containers';
import { displayLocalDate } from '../../../helpers/date';

const ReservationInfo = ({
  reservation, customer, showDeposit = false, withLink = false, type = 'reservation',
  onActionSuccessful = null, repliedMessageId = null, onClickCalendar = null,
  ...props
}) => {
  const message = (reservation.message || '').replace(/\n/g, '<br>');
  const url = () => {
    const root = type === 'reservation' ? 'reservations' : 'inquiries';
    return `/daily-rental/${root}/${reservation.id}`;
  };
  const ItemActions = type === 'reservation' ? ReservationActions : InquiryActions;
  const title = ['offered', 'aborted'].includes(reservation.status) ? 'offer' : type;
  return (
    <div>
      {
        reservation.error_code
          ? <div style={{color: 'red', border: '1px red solid', padding: '5px', margin: '10px 0'}}>
              <b>Error</b>
              <p>{ reservation.error_message }</p>
            </div>
          : null
      }
      <table className="table table-bordered table-striped details">
        {
          withLink
            ? <thead>
                <tr className="info">
                  <th colSpan="2">
                    { title.toUpperCase() } #{ reservation.reference } <ItemActions { ...props } inquiry={ reservation } reservation={ reservation } repliedMessageId={ repliedMessageId } onActionSuccessful={ onActionSuccessful }/>
                  </th>
                </tr>
              </thead>
            : null
        }
        <tbody>
          <tr>
            <td>Date</td>
            <td>{ displayLocalDate(reservation.creation_date) }</td>
          </tr>
          <tr>
            <td>Origin</td>
            <td>{ reservation.origin }</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>
              {
                type === 'reservation'
                  ? reservation.status
                  : reservation.processed ? 'processed' : 'pending'
              }
            </td>
          </tr>
          <tr>
            <td>Property</td>
            <td>{ reservation.property.name }</td>
          </tr>
          <tr>
            <td>Customer</td>
            <td>{ customer.name }</td>
          </tr>
          <tr>
            <td>Guests</td>
            <td>
              { reservation.nb_total_people }&nbsp;
              ({ reservation.nb_total_adults } adult{ reservation.nb_total_adults === 1 ? '' : 's'}, { reservation.nb_total_children } child{ reservation.nb_total_children === 1 ? '' : 'ren'})
            </td>
          </tr>
          <tr>
            <td>Arrival / Departure</td>
            <td>
              { moment(reservation.arrival_date).format('DD/MM/YYYY') } - { moment(reservation.departure_date).format('DD/MM/YYYY') }&nbsp;
              ({ reservation.nb_nights } night{ reservation.nb_nights === 1 ? '' : 's'})
            </td>
          </tr>
          <tr>
            <td>Total price</td>
            <td>
              {
                !reservation.price_not_communicated
                  ? <span>
                      { (reservation.total_price || 0).toFixed(2) } { reservation.currency }&nbsp;
                      ({ (reservation.total_price_per_night || 0).toFixed(2) } { reservation.currency } per night)
                    </span>
                  : <span>prices not communicated</span>
              }
            </td>
          </tr>
          <tr>
            <td>Dates available</td>
            <td>
              { reservation.available ? 'Yes' : 'No' }&nbsp;
              {
                onClickCalendar
                  ? <button type="button" className="btn btn-xs btn-info" onClick={ onClickCalendar }>Show calendar</button>
                  : null
              }
            </td>
          </tr>
          {
            showDeposit
              ? <tr>
                  <td>Deposit</td>
                  <td>
                    { reservation.deposit } { reservation.currency }&nbsp;
                    {
                      !reservation.deposit_paid
                        ? <span className="text-danger"><i className="fas fa-remove"/> not paid</span>
                        : <span className="text-success"><i className="fas fa-check"/> paid </span>
                    }
                  </td>
                </tr>
              : null
          }
        </tbody>
      </table>
      <div className="text-block" dangerouslySetInnerHTML={{__html: message }}></div>
    </div>
  );
};

export default ReservationInfo;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/ReservationInfo.jsx